let seq = 0;
export const nextKey = () => ++seq;
export const withKey = (item) => ({ ...item, _k: nextKey() });
export const stripKey = ({ _k, ...rest }) => rest;
